import React from 'react';

import ReportAPI from '../../api/ReportAPI';
import ReportConst from '../../util/ReportConst';
import ApiUiController from '../../controller/ApiUiController';

import ReportSelect from './ReportSelect';
import ReportSelectToSelect from './ReportSelectToSelect';
import ReportSelectToTime from './ReportSelectToTime';
import ReportSelectToMonth from './ReportSelectToMonth';

class DashboardItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = { inApiCall : true, report: null };
  }

  componentDidMount() { ReportAPI.get(this.props.id, this.onReport); }

  onReport = res => this.setState({ ...this.state, inApiCall: false, report: res});

  render() {
    let report = <div></div>;
    if(this.state.report && this.state.report.type === ReportConst.Select) {
      report = <ReportSelect report={this.state.report} filters={this.props.filters}
        dashbaord={true} />
    } else if(this.state.report && this.state.report.type === ReportConst.SelectToSelect) {
      report = <ReportSelectToSelect report={this.state.report} filters={this.props.filters}
        dashbaord={true} />
    } else if(this.state.report && this.state.report.type === ReportConst.SelectToTime) {
      report = <ReportSelectToTime report={this.state.report}  filters={this.props.filters} />
    } else if(this.state.report && this.state.report.type === ReportConst.SelectToMonth) {
      report = <ReportSelectToMonth report={this.state.report}  filters={this.props.filters} />
    }
    return( <ApiUiController inApiCall={this.state.inApiCall}> {report} </ApiUiController> );
  }
}
export default DashboardItem;